import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col space-y-8"
}
const _hoisted_2 = { class: "flex flex-col w-full space-y-3" }
const _hoisted_3 = { class: "flex flex-row items-center space-x-3" }
const _hoisted_4 = { class: "text-2xl font-bold text-accent" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400 italic" }, "(Actif)", -1)
const _hoisted_6 = { class: "w-full text-gray-400" }
const _hoisted_7 = { class: "flex flex-row space-x-4" }
const _hoisted_8 = { class: "grid w-full grid-cols-3 gap-4 p-5 border border-opacity-20 rounded-xl" }
const _hoisted_9 = { class: "flex flex-col space-y-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 font-medium" }, "Informations supplémentaires", -1)
const _hoisted_11 = { class: "text-gray-400" }
const _hoisted_12 = { class: "text-gray-400" }
const _hoisted_13 = { class: "text-gray-400" }
const _hoisted_14 = { class: "text-gray-400" }
const _hoisted_15 = { class: "flex flex-col space-y-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 font-medium" }, "Statistiques Techniques", -1)
const _hoisted_17 = { class: "text-gray-400" }
const _hoisted_18 = { class: "text-gray-400" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400" }, "NaN Incidents les 30 derniers jours", -1)
const _hoisted_20 = { class: "flex flex-col space-y-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 font-medium" }, "Autres Statistiques", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400" }, "NaN XAF de chiffre d'affaires", -1)
const _hoisted_23 = { class: "text-gray-400" }
const _hoisted_24 = { class: "text-gray-400" }

import api from "@/api";
import { inject, onBeforeMount, ref } from "vue";

	/**
	 * Variables
	 */
	
export default /*#__PURE__*/_defineComponent({
  __name: 'DetailsAgency',
  setup(__props) {

	const selectedRow = ref({});
	const isLoading = ref(false);
	const stationIDSelected: any = ref(inject("stationIDSelected"));
	const stationInfos = ref<any>();

	/**
	 * Functions
	 */
	const getStationInfos = async () => {
		isLoading.value = true;
		await api()
			.stations.get(stationIDSelected.value)
			.then((res: any) => {
				stationInfos.value = res.data;
			})
			.catch((err: any) => {
				console.log(err);
			});
		isLoading.value = false;
	};

	/**
	 * Lifecycle
	 */
	onBeforeMount(async () => {
		await getStationInfos();
	});

return (_ctx: any,_cache: any) => {
  const _component_ImageView = _resolveComponent("ImageView")!
  const _component_StationDetailSkeleton = _resolveComponent("StationDetailSkeleton")!
  const _component_SkeletonLoader = _resolveComponent("SkeletonLoader")!

  return (isLoading.value == false)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(stationInfos.value?.station_name ?? "Not defined"), 1),
            _hoisted_5
          ]),
          _createElementVNode("p", _hoisted_6, _toDisplayString(stationInfos.value?.description ?? "(Aucune description défini"), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, " Contacts : " + _toDisplayString(stationInfos.value?.station_phone ?? "Not defined"), 1),
              _createElementVNode("div", _hoisted_12, " E-mail : " + _toDisplayString(stationInfos.value?.station_email ?? "Not defined"), 1),
              _createElementVNode("div", _hoisted_13, " Addesse : " + _toDisplayString(stationInfos.value?.station_address ?? "Not defined"), 1),
              _createElementVNode("div", _hoisted_14, " Boite postale : " + _toDisplayString(stationInfos.value?.postal_box ?? "Not defined"), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, _toDisplayString(stationInfos.value?.users_count) + " Personnel(s)", 1),
              _createElementVNode("div", _hoisted_18, _toDisplayString(stationInfos.value?.managers_count < 2 ? 0 : stationInfos.value?.managers_count - 1) + " Manager(s)/Directeur(s) ", 1),
              _hoisted_19
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, _toDisplayString(stationInfos.value?.passengers_count) + " Passager(s) au total", 1),
              _createElementVNode("div", _hoisted_24, _toDisplayString(stationInfos.value?.embarkations_count) + " Embarquement(s)", 1)
            ])
          ]),
          _createVNode(_component_ImageView, {
            src: "/media/images/thumbnail-3-img.svg",
            css: "h-[200px] rounded-xl w-1/2"
          })
        ])
      ]))
    : (_openBlock(), _createBlock(_component_SkeletonLoader, { key: 1 }, {
        default: _withCtx(() => [
          _createVNode(_component_StationDetailSkeleton)
        ]),
        _: 1
      }))
}
}

})